export const normalizeUserPayload = (payload) => {
	if (Array.isArray(payload)) {
		return payload[0] ?? null;
	}

	return payload ?? null;
};

export const normalizeRoutineCreationType = (value) => {
	const normalizedValue = String(value || '').trim().toLowerCase();

	if (normalizedValue === 'generated' || normalizedValue === 'ai') {
		return 'generated';
	}

	if (
		normalizedValue === 'created'
		|| normalizedValue === 'manual'
		|| normalizedValue === ''
	) {
		return 'created';
	}

	return normalizedValue;
};
